// dna_frontend/src/pages/LietSiManagement.js
// (*** ĐÃ SỬA PHÂN QUYỀN CHO USER XÃ ***)

import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import './LietSiManagement.css'; 

// (Modal Component - Giữ nguyên)
const LietSiModal = ({ open, onClose, onSave, lietSi, xaPhuongList, isAdmin, userXaId }) => {
    const [formData, setFormData] = useState({ ho_ten: '', thon_info: '', xa_id: '' });
    const [error, setError] = useState('');
    useEffect(() => {
        if (open) {
            if (lietSi) { 
                setFormData({ ho_ten: lietSi.ho_ten || '', thon_info: lietSi.thon_info || '', xa_id: lietSi.xa_id || '' }); 
            } else { 
                // (Sửa) Nếu là Xã, tự động điền xã của họ
                setFormData({ ho_ten: '', thon_info: '', xa_id: isAdmin ? '' : userXaId }); 
            }
            setError('');
        }
    }, [open, lietSi, isAdmin, userXaId]);
    
    const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value }); };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!formData.ho_ten || !formData.xa_id) { setError('Họ tên Liệt sĩ và Xã là bắt buộc.'); return; }
        try {
            await onSave(formData);
            onClose(); 
        } catch (err) { setError(err.response?.data?.message || 'Lỗi khi lưu'); }
    };
    if (!open) return null;
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>{lietSi ? 'Sửa thông tin Liệt sĩ' : 'Thêm mới Liệt sĩ'}</h3>
                {error && <p className="modal-error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group"><label>Họ tên Liệt sĩ (*)</label><input type="text" name="ho_ten" value={formData.ho_ten} onChange={handleChange} required /></div>
                    <div className="form-group"><label>Thôn/xóm (nếu trùng tên)</label><input type="text" name="thon_info" value={formData.thon_info} onChange={handleChange} placeholder="Ví dụ: Thôn A" /></div>
                    
                    {/* (Sửa) Xã không được chọn xã */}
                    <div className="form-group">
                        <label>Xã/Phường (*)</label>
                        <select name="xa_id" value={formData.xa_id} onChange={handleChange} required disabled={!isAdmin}>
                            <option value="">-- Chọn xã --</option>
                            {xaPhuongList.map(xa => (<option key={xa.id} value={xa.id}>{xa.ten_xa}</option>))}
                        </select>
                    </div>

                    <div className="modal-actions"><button type="button" onClick={onClose} className="btn-secondary">Hủy</button><button type="submit" className="btn-primary">Lưu</button></div>
                </form>
            </div>
        </div>
    );
};


// Component chính
function LietSiManagement() {
    // (*** MỚI ***) Lấy thông tin user
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    
    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        setUser(storedUser);
        setIsAdmin(storedUser?.role === 'admin');
    }, []);

    const [tab, setTab] = useState('stats'); 
    
    // State cho Thống kê
    const [stats, setStats] = useState(null);
    const [loadingStats, setLoadingStats] = useState(true);
    
    // State cho Danh sách
    const [list, setList] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [filters, setFilters] = useState({ ten_ls: '', xa_id: '', chua_co_than_nhan: false });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    
    const [selectedIds, setSelectedIds] = useState([]);

    // State chung
    const [xaPhuongList, setXaPhuongList] = useState([]);
    const [error, setError] = useState('');

    // State cho Modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentLietSi, setCurrentLietSi] = useState(null); 

    // Tải dữ liệu ban đầu
    useEffect(() => {
        // (Sửa) Chỉ tải khi đã xác định được user
        if (user) {
            fetchStats();
            if (isAdmin) { // Chỉ Admin mới cần DS xã (để lọc)
                fetchXaPhuong();
            }
        }
    }, [user, isAdmin]); // Chạy lại khi user/isAdmin thay đổi

    // Tải danh sách
    const fetchList = useCallback(async (page, currentFilters) => {
        if (!user) return; // Không chạy nếu chưa có user
        
        setLoadingList(true);
        setError('');
        setSelectedIds([]);
        try {
            const params = new URLSearchParams({ page: page, limit: 20 });
            if (currentFilters.ten_ls) params.append('ten_ls', currentFilters.ten_ls);
            if (currentFilters.chua_co_than_nhan) params.append('chua_co_than_nhan', 'true');

            // (*** SỬA ***) Logic phân quyền
            if (isAdmin) {
                // Admin: Lấy filter từ dropdown
                if (currentFilters.xa_id) params.append('xa_id', currentFilters.xa_id);
            } else {
                // User Xã: Ép filter theo xã của user
                params.append('xa_id', user.xa_id);
            }

            const res = await api.get(`/lietsi?${params.toString()}`);
            setList(res.data.data);
            setTotalPages(res.data.totalPages);
            setCurrentPage(res.data.currentPage);
        } catch (err) {
            setError('Lỗi tải danh sách liệt sĩ');
        } finally {
            setLoadingList(false);
        }
    }, [user, isAdmin]); // Thêm user, isAdmin vào dependencies

    // Tải thống kê
    const fetchStats = async () => {
        setLoadingStats(true);
        setError('');
        try {
            // (Sửa) API này phải được gọi bởi cả Xã và Admin
            const res = await api.get('/lietsi/stats');
            setStats(res.data);
        } catch (err) {
            setError('Lỗi tải dữ liệu thống kê');
        } finally {
            setLoadingStats(false);
        }
    };

    // Tải danh sách Xã
    const fetchXaPhuong = async () => {
        try {
            const res = await api.get('/data/xaphuong');
            setXaPhuongList(res.data);
        } catch (err) {
            console.error("Lỗi tải danh sách xã", err);
        }
    };
    
    // Xử lý khi đổi tab
    useEffect(() => {
        if (tab === 'list' && list.length === 0 && user) {
            fetchList(1, filters);
        }
    }, [tab, list.length, fetchList, filters, user]);
    
    // Xử lý Filter
    const handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        fetchList(1, filters);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            fetchList(newPage, filters);
        }
    };
    
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedIds(list.map(ls => ls.id));
        } else {
            setSelectedIds([]);
        }
    };

    const handleSelectOne = (id) => {
        setSelectedIds(prev => 
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };
    
    // Xử lý CRUD
    const handleSave = async (formData) => {
        if (currentLietSi) {
            // Sửa
            await api.put(`/lietsi/${currentLietSi.id}`, formData);
        } else {
            // Thêm mới
            await api.post('/lietsi', formData); 
        }
        fetchList(1, filters); 
    };

    const handleDelete = async (lietSiId, hoTen) => {
        if (window.confirm(`Bạn có chắc muốn XÓA liệt sĩ [${hoTen}]? Thao tác này sẽ xóa cả các mối quan hệ.`)) {
            try {
                await api.delete(`/lietsi/${lietSiId}`);
                fetchList(currentPage, filters); 
            } catch (err) {
                setError(err.response?.data?.message || 'Lỗi khi xóa');
            }
        }
    };
    
    const handleDeleteSelected = async () => {
        if (selectedIds.length === 0) {
            alert("Vui lòng chọn ít nhất một liệt sĩ để xóa.");
            return;
        }
        if (window.confirm(`Bạn có chắc muốn XÓA ${selectedIds.length} liệt sĩ đã chọn?`)) {
            try {
                await api.post('/lietsi/delete-multiple', { ids: selectedIds });
                fetchList(1, filters); 
            } catch (err) {
                 setError(err.response?.data?.message || 'Lỗi khi xóa hàng loạt');
            }
        }
    };
    
    const getStatusColor = (status) => {
        if (status === 'da_thu_mau') return 'green';
        if (status === 'chua_thu') return 'gray';
        return 'red';
    };

    return (
        <div className="liet-si-container">
            <h1>Quản lý & Thống kê Liệt sĩ {user && !isAdmin ? `(Xã: ${user.xa_id})` : ''}</h1>
            {error && <p className="error-message">{error}</p>}

            <div className="tabs">
                <button onClick={() => setTab('stats')} className={tab === 'stats' ? 'active' : ''}>
                    Thống kê Tiến độ
                </button>
                <button onClick={() => setTab('list')} className={tab === 'list' ? 'active' : ''}>
                    Danh sách Liệt sĩ
                </button>
            </div>

            {/* --- TAB THỐNG KÊ --- */}
            {tab === 'stats' && (
                <div className="stats-section">
                    {loadingStats && <p>Đang tải thống kê...</p>}
                    {stats && (
                        <>
                            <h3>Thống kê Tổng (Toàn tỉnh)</h3>
                            <table className="stats-table">
                                <thead>
                                    <tr>
                                        <th>Loại</th>
                                        <th>Tổng số Liệt sĩ</th>
                                        <th>Đã thu đủ</th>
                                        <th>Mới thu 1</th>
                                        <th>Chưa thu</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Liệt sĩ có 1 Thân nhân</td>
                                        <td>{stats.totals.LS_Co_1_TN}</td>
                                        <td>{stats.totals.LS_Co_1_TN_DaThu_1}</td>
                                        <td></td> 
                                        <td>{stats.totals.LS_Co_1_TN - stats.totals.LS_Co_1_TN_DaThu_1}</td>
                                    </tr>
                                    <tr>
                                        <td>Liệt sĩ có 2+ Thân nhân</td>
                                        <td>{stats.totals.LS_Co_2_TN}</td>
                                        <td>{stats.totals.LS_Co_2_TN_DaThu_2}</td>
                                        <td>{stats.totals.LS_Co_2_TN_DaThu_1}</td>
                                        <td>{stats.totals.LS_Co_2_TN_DaThu_0}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <h3>Thống kê Chi tiết (Theo Xã)</h3>
                            <div className="table-wrapper">
                                <table className="stats-table detailed-stats">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2">Tên Xã</th>
                                            <th rowSpan="2">Tổng LS</th>
                                            <th colSpan="3">LS có 1 Thân nhân</th>
                                            <th colSpan="4">LS có 2+ Thân nhân</th>
                                        </tr>
                                        <tr>
                                            <th>Tổng (1)</th>
                                            <th>Đã thu (1/1)</th>
                                            <th>Chưa thu (0/1)</th>
                                            <th>Tổng (2+)</th>
                                            <th>Đã thu (2/2)</th>
                                            <th>Mới thu (1/2)</th>
                                            <th>Chưa thu (0/2)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stats.byXa.map(xa => (
                                            <tr key={xa.xa_id}>
                                                <td>{xa.ten_xa}</td>
                                                <td>{xa.TongSoLietSi}</td>
                                                <td>{xa.LS_Co_1_TN}</td>
                                                <td>{xa.LS_Co_1_TN_DaThu_1}</td>
                                                <td>{xa.LS_Co_1_TN - xa.LS_Co_1_TN_DaThu_1}</td>
                                                <td>{xa.LS_Co_2_TN}</td>
                                                <td>{xa.LS_Co_2_TN_DaThu_2}</td>
                                                <td>{xa.LS_Co_2_TN_DaThu_1}</td>
                                                <td>{xa.LS_Co_2_TN_DaThu_0}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            )}

            {/* --- TAB DANH SÁCH (CRUD) --- */}
            {tab === 'list' && (
                <div className="list-section">
                    <form onSubmit={handleFilterSubmit} className="filter-form">
                        <div className="filter-grid">
                            <input
                                type="text"
                                name="ten_ls"
                                value={filters.ten_ls}
                                onChange={handleFilterChange}
                                placeholder="Tìm theo tên Liệt sĩ..."
                            />
                            {/* (*** SỬA ***) Chỉ Admin thấy Lọc Xã */}
                            {isAdmin && (
                                <select name="xa_id" value={filters.xa_id} onChange={handleFilterChange}>
                                    <option value="">-- Lọc theo xã --</option>
                                    {xaPhuongList.map(xa => (
                                        <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>
                                    ))}
                                </select>
                            )}
                        </div>
                        <div className="filter-checkbox">
                            <input
                                type="checkbox"
                                name="chua_co_than_nhan"
                                id="chua_co_than_nhan"
                                checked={filters.chua_co_than_nhan}
                                onChange={handleFilterChange} 
                            />
                            <label htmlFor="chua_co_than_nhan">Chỉ hiển thị Liệt sĩ chưa có thân nhân</label>
                        </div>
                        <div className="filter-actions">
                            <button type="submit" className="btn-primary">Lọc</button>
                            <button
                                type="button"
                                onClick={() => {
                                    const emptyFilters = { ten_ls: '', xa_id: '', chua_co_than_nhan: false };
                                    setFilters(emptyFilters);
                                    fetchList(1, emptyFilters);
                                }}
                                className="btn-secondary"
                            >
                                Xóa lọc
                            </button>
                            {/* (*** SỬA ***) Chỉ Admin thấy Xóa Hàng loạt */}
                            {isAdmin && (
                                <button
                                    type="button"
                                    onClick={handleDeleteSelected}
                                    className="btn-danger"
                                    style={{ marginLeft: 'auto' }}
                                    disabled={selectedIds.length === 0}
                                >
                                    Xóa ({selectedIds.length}) đã chọn
                                </button>
                            )}
                            {/* (Sửa) Nút Thêm mới ở vị trí khác nhau tùy role */}
                            <button
                                type="button"
                                onClick={() => { setCurrentLietSi(null); setIsModalOpen(true); }}
                                className="btn-success"
                                style={!isAdmin ? { marginLeft: 'auto' } : {}} 
                            >
                                + Thêm mới Liệt sĩ
                            </button>
                        </div>
                    </form>

                    {loadingList && <p>Đang tải danh sách...</p>}
                    <div className="table-wrapper">
                        <table className="crud-table">
                            <thead>
                                <tr>
                                    {/* (*** SỬA ***) Chỉ Admin thấy Checkbox */}
                                    {isAdmin && (
                                        <th style={{ width: '40px' }}>
                                            <input 
                                                type="checkbox" 
                                                onChange={handleSelectAll}
                                                checked={list.length > 0 && selectedIds.length === list.length}
                                            />
                                        </th>
                                    )}
                                    <th>Họ tên Liệt sĩ</th>
                                    <th>Thôn/Xóm</th>
                                    {isAdmin && <th>Xã</th>} 
                                    <th>Thông tin Thân nhân liên quan</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list.length === 0 && !loadingList && (
                                    <tr><td colSpan={isAdmin ? 6 : 5} style={{textAlign: 'center'}}>Không có dữ liệu.</td></tr>
                                )}
                                {list.map(ls => (
                                    <tr key={ls.id} className={isAdmin && selectedIds.includes(ls.id) ? 'row-selected' : ''}>
                                        {isAdmin && (
                                            <td>
                                                <input 
                                                    type="checkbox"
                                                    checked={selectedIds.includes(ls.id)}
                                                    onChange={() => handleSelectOne(ls.id)}
                                                />
                                            </td>
                                        )}
                                        <td>{ls.ho_ten}</td>
                                        <td>{ls.thon_info}</td>
                                        {isAdmin && <td>{ls.ten_xa}</td>}
                                        <td>
                                            {ls.ThongTinThanNhan.length === 0 ? (
                                                <small>Chưa có thân nhân</small>
                                            ) : (
                                                <ul className="than-nhan-sublist">
                                                    {ls.ThongTinThanNhan.map((tn, idx) => (
                                                        <li key={idx}>
                                                            {tn.ho_ten} (CCCD: {tn.cccd})
                                                            <strong style={{ color: getStatusColor(tn.trang_thai_thu_mau), marginLeft: '5px' }}>
                                                                [{tn.trang_thai_thu_mau}]
                                                            </strong>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </td>
                                        <td className="actions-cell">
                                            <button 
                                                onClick={() => { setCurrentLietSi(ls); setIsModalOpen(true); }}
                                                className="btn-edit"
                                            >
                                                Sửa
                                            </button>
                                            <button 
                                                onClick={() => handleDelete(ls.id, ls.ho_ten)}
                                                className="btn-delete"
                                            >
                                                Xóa
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {totalPages > 0 && (
                        <div className="pagination">
                            <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
                            <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
                            <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
                        </div>
                    )}
                </div>
            )}
            
            <LietSiModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSave}
                lietSi={currentLietSi}
                xaPhuongList={xaPhuongList}
                isAdmin={isAdmin} // (*** MỚI ***)
                userXaId={user?.xa_id} // (*** MỚI ***)
            />
        </div>
    );
}

export default LietSiManagement;